import { useTheme } from "styled-components";
import { Svg, SvgProps } from "@pancakeswap/uikit";

interface MultiplierProps extends SvgProps {
  isActive: boolean;
}

export const RoundMultiplierDownArrow: React.FC<
  React.PropsWithChildren<MultiplierProps>
> = ({ isActive, ...props }) => {
  const theme = useTheme();
  const fill = theme.colors[isActive ? "failure" : "multiplierCardBg"];

  return (
    <Svg width="270" height="57" viewBox="0 0 270 57" {...props}>
      <rect x="18.5" y="5" width="233" height="4" rx="2" fill={fill} />
      <rect x="36.5" y="13" width="197" height="4" rx="2" fill={fill} />
      <rect x="54.5" y="21" width="161" height="4" rx="2" fill={fill} />
      <rect x="73.5" y="29" width="123" height="4" rx="2" fill={fill} />
      <rect x="91.5" y="37" width="87" height="4" rx="2" fill={fill} />
      <rect x="110.5" y="45" width="49" height="4" rx="2" fill={fill} />
      <rect x="128.5" y="53" width="13" height="4" rx="2" fill={fill} />
      <rect
        y="1"
        width="270"
        height="56"
        fill="url(#paint0_linear_3853_6594)"
      />
      <path
        d="M0 1H270V-1H0V1Z"
        fill="white"
        fill-opacity="0.1"
        mask="url(#path-1-inside-1_3853_6594)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3853_6594"
          x1="135"
          y1="1"
          x2="135"
          y2="57"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#050217" />
          <stop offset="1" stop-color="#050217" stop-opacity="0" />
        </linearGradient>
      </defs>
    </Svg>
  );
};

export const RoundMultiplierUpArrow: React.FC<
  React.PropsWithChildren<MultiplierProps>
> = ({ isActive, ...props }) => {
  const theme = useTheme();
  const fill = theme.colors[isActive ? "success" : "multiplierCardBg"];

  return (
    <Svg width="270" height="57" viewBox="0 0 270 57" {...props}>
      <rect x="128.5" width="13" height="4" rx="2" fill={fill} />
      <rect x="110.5" y="8" width="49" height="4" rx="2" fill={fill} />
      <rect x="91.5" y="16" width="87" height="4" rx="2" fill={fill} />
      <rect x="73.5" y="24" width="123" height="4" rx="2" fill={fill} />
      <rect x="54.5" y="32" width="161" height="4" rx="2" fill={fill} />
      <rect x="36.5" y="40" width="197" height="4" rx="2" fill={fill} />
      <rect x="18.5" y="48" width="233" height="4" rx="2" fill={fill} />
      <rect width="270" height="56" fill="url(#paint0_linear_3853_6391)" />
      <path
        d="M270 56H0V58H270V56Z"
        fill="white"
        fill-opacity="0.1"
        mask="url(#path-1-inside-1_3853_6391)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3853_6391"
          x1="135"
          y1="0"
          x2="135"
          y2="56"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#050217" stop-opacity="0" />
          <stop offset="1" stop-color="#050217" />
        </linearGradient>
      </defs>
    </Svg>
  );
};
